import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { lastValueFrom } from 'rxjs';
import { AuthService } from './auth.service';

export const verifyTokenGuard: CanActivateFn = () => {
  const authService = inject(AuthService);
  const router = inject(Router);

  const firstTime = localStorage.getItem('firstTime');
  const profile = authService.getUser();

  if (firstTime === 'true') {
    return true;
  }

  if (!profile) {
    return router.createUrlTree(['/auth/login']);
  }

  if (!profile.is_set_password) {
    return true;
  }

  return router.createUrlTree(['/']);
};
